import { render, staticRenderFns } from "./Merch.vue?vue&type=template&id=079316f4&"
import script from "./Merch.vue?vue&type=script&lang=js&"
export * from "./Merch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/miryamfv/Proyectos/valet/dz0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('079316f4')) {
      api.createRecord('079316f4', component.options)
    } else {
      api.reload('079316f4', component.options)
    }
    module.hot.accept("./Merch.vue?vue&type=template&id=079316f4&", function () {
      api.rerender('079316f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/Merch.vue"
export default component.exports